/* JS - Destellos Mexicanos 🇲🇽 */

document.addEventListener("DOMContentLoaded", function () {

  const sparkleContainer = document.createElement("div");
  sparkleContainer.classList.add("mexico-sparkle-container");
  document.body.appendChild(sparkleContainer);

  const colores = [
    "#006847", // Verde México
    "#FFFFFF", // Blanco
    "#CE1126"  // Rojo
  ];

  const formas = ["✦", "✧", "✦", "✧"];

  for (let i = 0; i < 45; i++) {

    const sparkle = document.createElement("div");

    sparkle.classList.add("mexico-sparkle");

    /* Posición */
    sparkle.style.left = Math.random() * 100 + "vw";
    sparkle.style.top = Math.random() * 100 + "vh";

    /* Color */
    const color =
      colores[Math.floor(Math.random() * colores.length)];

    sparkle.style.color = color;

    /* Glow del mismo color */
    sparkle.style.setProperty("--sparkle-color", color);

    /* Tamaños diferentes */
    sparkle.style.fontSize =
      10 + Math.random() * 22 + "px";

    /* Velocidad del destello */
    sparkle.style.animationDuration =
      1.8 + Math.random() * 3.5 + "s";

    /* Evita que todos aparezcan al mismo tiempo */
    sparkle.style.animationDelay =
      Math.random() * 5 + "s";

    /* Forma */
    sparkle.innerHTML =
      formas[Math.floor(Math.random() * formas.length)];

    sparkleContainer.appendChild(sparkle);
  }

});

